export const makePaymentDashboardElem = $('#balance_container')

// Dashboard loading
export const makePaymentDashboardLoadingElem = makePaymentDashboardElem.find('#balance-placeholder')

// Dashboard recurring payments
export const makePaymentRecurringElem = $('.make-payment-banner-panel')
export const makePaymentRecurringButtonElem = makePaymentRecurringElem.find('#schedule_recurring_button')

// Dashboard errors
export const makePaymentAccountingErrorElem = $('#accounting_errors')
export const makePaymentPaymentErrorElem = $('#payment_errors')

// Dashboard balance
export const makePaymentDashboardBalanceUnavailableElem = makePaymentDashboardElem.find('#dashboard_balance_unavailable')
export const makePaymentDashboardBalanceAttorneyElem = makePaymentDashboardElem.find('#balance_attorney')
export const makePaymentDashboardBalanceElem = makePaymentDashboardElem.find('#balance_info')
export const makePaymentDashboardBalanceAmountElem = makePaymentDashboardElem.find('#dashboard_balance_value')
export const makePaymentDashboardBalanceDateElem = makePaymentDashboardElem.find('#dashboard_balance_date')
export const makePaymentDashboardLastPaymentDateElem = makePaymentDashboardElem.find('#last_payment_date')
export const makePaymentDashboardLastPaymentInfoElem = makePaymentDashboardElem.find('#last_payment_info')

// Dashboard make payment button
export const makePaymentDashboardPaymentButtonElem = $('#make_payment_button')
export const makePaymentDashboardPaymentContainerElem = $('.button-make-payment-container')

// Dashboard data attributes
export const makePaymentDashboardUrlData = makePaymentDashboardElem.attr('data-payment-url')
export const makePaymentDashboardLogUrlData = makePaymentDashboardElem.attr('data-log-url')
export const makePaymentDashboardTrackUrlData = makePaymentRecurringElem.attr('data-track-url')
export const makePaymentProviderData = makePaymentDashboardElem.attr('data-provider')
export const aptexxModalImplementation = makePaymentDashboardElem.attr('data-aptexx-modal-implementation')

// Multiple Ledgers
export const accountAndBalancesContainer = $('.accounts-and-balances')
export const unitsSelectContainer = $('.unit-container')
export const unitsSelectElem = $('#unitsPaymentDropdown')
export const multipleLedgersContainer = $('.multiple-ledgers-container')
